module.exports = __webpack_public_path__ + "img/zuijia_51.a68e591d.png";